import React, { useEffect, useRef, useState } from "react";
import lod_ from "lodash";

import DropMenu from "components/Menu/DropMenu";
import { useDispatch, useSelector } from "react-redux";
import cockpitActions from "../../../redux/actions/cockpitActions";
import DictionaryExplorer from "../DictionaryExplorer";
import { getValidTypesForText } from "helpers/utilities";
import { te } from "date-fns/locale";
import { useTheme } from "theme";

// if there is to little text selected, don't put popover
const MINIMUM_TEXT_TO_SELECT = 2;

const TextSelectActionPopover = ({ target, forceClose }) => {
	const { isDarkMode } = useTheme();

	const [selectedText, setSelectedText] = useState("");
	const [actionsText, setActionsText] = useState([]);
	const [openExtraDialog, setOpenExtraDialog] = useState(false);
	const [validTypes, setValidTypes] = useState([]);
	const { userStatus } = useSelector(state => state);

	const selectedConversation = useSelector(state => state.cockpit.selectedConversation);
	const dispatch = useDispatch();
	const outerRef = useRef();

	const actions = useSelector(state => state?.assistantconfig?.actions);

	function handleActionText(actionConfig) {
		if (actionConfig.version === "2.0") {
			switch (actionConfig.type) {
				case "updateContext":
					setOpenExtraDialog(outerRef);
					break;
				default:
					break;
			}
		} else {
			switch (actionConfig.code) {
				case "setTextToContext":
					setOpenExtraDialog(outerRef);
					break;
				default:
					break;
			}
		}
	}

	function handleSetTextToContext(path) {
		const data = {
			header: {
				assistantID: selectedConversation?.header?.assistantID,
				fID: selectedConversation?.header?.fID
			},
			payload: {}
		};

		data.payload[path] = selectedText.text;

		setOpenExtraDialog(false);
		dispatch(cockpitActions.launchActionFrontV2("updateConvDictionaryPartial", data));
		setSelectedText("");
	}

	useEffect(() => {
		if (forceClose) {
			setSelectedText("");
		}
	}, [forceClose]);

	/**
	 * Gestion of name with new format action front v2
	 * Get language of profile to get correct action name or default to english or first available
	 */
	const buildActionName = action => {
		const language = userStatus?.auth?.user?.language?.toUpperCase();
		let nameOfAction = action.name;
		if (!lod_.isNil(action.actionName) && !lod_.isEmpty(action.actionName)) {
			if (!lod_.isNil(language) && !lod_.isNil(action.actionName[language])) {
				nameOfAction = action.actionName[language];
			} else {
				nameOfAction = action.actionName.EN ?? Object.values(action.actionName)[0] ?? action.name;
			}
		}

		return nameOfAction;
	};

	useEffect(() => {
		const actionsTextCompute =
			actions
				?.filter(act => act.scope === "text")
				.map(action => {
					let tempObject = lod_.cloneDeep(action);

					tempObject.name = buildActionName(action);

					return tempObject;
				})
				.sort((a, b) => {
					const rankA = a.rank ?? Infinity;
					const rankB = b.rank ?? Infinity;
					return rankA - rankB;
				}) || [];

		setActionsText(actionsTextCompute);

		function handleMouseUp() {
			const selection = window.getSelection();
			const text = selection.toString();

			const textNotEmpty = text.trim().length >= MINIMUM_TEXT_TO_SELECT;

			const diplayCondition =
				!selection.isCollapsed && textNotEmpty && actionsTextCompute?.length > 0;

			if (diplayCondition) {
				const range = selection.getRangeAt(0);
				const rect = range.getBoundingClientRect();

				setSelectedText({
					text: selection.toString(),
					x: rect.right + 6,
					y: rect.top - 4
				});
			} else if (selection.isCollapsed && textNotEmpty && actionsTextCompute?.length > 0) {
				setSelectedText({
					text: selection.toString(),
					x: target.current.getBoundingClientRect().left,
					y: target.current.getBoundingClientRect().top + -50
				});
			} else {
				setSelectedText("");
			}
		}

		if (target?.current) {
			target.current.addEventListener("mouseup", handleMouseUp);
		}

		return () => {
			if (target?.current) {
				target.current.removeEventListener("mouseup", handleMouseUp);
			}
		};
	}, []);

	useEffect(() => {
		// When selected text changes, recompute which types are available for the string.
		// It can be phone, string, email..
		setValidTypes(getValidTypesForText(selectedText.text));
	}, [selectedText]);

	return (
		selectedText &&
		selectedConversation && (
			<div
				ref={outerRef}
				style={{
					position: "fixed",
					left: selectedText.x,
					top: selectedText.y,
					backgroundColor: isDarkMode ? "var(--dark-bg-elevated)" : "white",
					color: "rgba(0, 0, 0, 0.38)",
					border: "1px solid rgba(0, 0, 0, 0.12)",
					padding: "5px",
					zIndex: 1000,
					borderRadius: "4px"
				}}
			>
				<DropMenu handleAction={handleActionText} items={actionsText} />
				<DictionaryExplorer
					open={openExtraDialog}
					position={{ left: selectedText.x, top: selectedText.y }}
					handleClick={dictionaryPath => {
						handleSetTextToContext(dictionaryPath);
					}}
					handleClose={() => {
						setOpenExtraDialog(false);
					}}
					validTypes={validTypes}
				/>
			</div>
		)
	);
};

export default TextSelectActionPopover;
